/* Program Name: TS.js
 **  Description: Axios config file
 **
 **
 ** Project   Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** IS200241  2021-03-17  stt  Initial program
 ** IS200324  2021-12-07  caa  Removing default setting for axios
 *********************************************************************************/

/**axios import  */

import Axios from 'axios' //DOCS: https://www.npmjs.com/package/axios
import { ezpopURL } from '../Components/Common/ezpopURL'

/**setting the base url for our ajax calls */
export default Axios.create({
  baseURL: `${ezpopURL}/data/`,
  withCredentials: true,
})
